// this is carrier compatible routes

import Layout from "@/layout";

export default {
  path: "/carrier",
  component: Layout,
  meta: { title: "Market Insight", icon: "loads-board-v2" },
  hidden: true,
  children: [
    {
      path: "market-insights/rate-check",
      name: "marketInsight",
      component: () => import("@/views/carrier-common/index.vue"),
      meta: {
        title: "Rate Check",
        tabKey: "Rate Check",
        system: "carrier",
        keepAlive: true,
      },
    },
    {
      path: "market-insights/profit-calculator",
      name: "marketInsight",
      component: () => import("@/views/carrier-common/index.vue"),
      meta: {
        title: "Load Profit Calculator",
        tabKey: "Load Profit Calculator",
        system: "carrier",
        keepAlive: true,
      },
    },
    {
      path: "market-insights/fuel-surcharge-calculator",
      name: "marketInsight",
      component: () => import("@/views/carrier-common/index.vue"),
      meta: {
        title: "Fuel Surcharge Calculator",
        tabKey: "Fuel Surcharge Calculator",
        system: "carrier",
        keepAlive: true,
      },
    },
    {
      path: "market-insights/capacity-indicator",
      name: "marketInsight",
      component: () => import("@/views/carrier-common/index.vue"),
      meta: {
        title: "Capacity Indicator",
        tabKey: "Capacity Indicator",
        system: "carrier",
        keepAlive: true,
      },
    },
    {
      path: "account/connect",
      name: " connect",
      component: () => import("@/views/carrier-common/index.vue"),
      meta: {
        title: "My Connected Broker",
        system: "carrier",
        keepAlive: true,
      },
    },
    {
      path: "account/connect/loadsmart",
      name: "profile",
      component: () => import("@/views/carrier-common/index.vue"),
      meta: {
        title: "Load Board",
        system: "carrier",
        keepAlive: true,
        showBack: true
      },
      hidden: true,
    },
    {
      path: "loads/loads-search",
      name: "profile",
      component: () => import("@/views/carrier-common/index.vue"),
      meta: {
        title: "Search Loads",
        system: "carrier",
        keepAlive: true,
      },
      hidden: true,
    },
    {
      path: "loads/load-alert",
      name: "loadAlert",
      component: () => import("@/views/carrier-common/index.vue"),
      meta: {
        title: "Load Alert",
        system: "carrier",
        keepAlive: true,
      },
    },
    {
      path: "loads/load-alert/load-list",
      name: "loadAlert",
      component: () => import("@/views/carrier-common/index.vue"),
      meta: {
        title: "Load Alert",
        system: "carrier",
        keepAlive: true,
      },
    },
    {
      path: "loads/density",
      name: "density",
      component: () => import("@/views/carrier-common/index.vue"),
      meta: {
        title: "Load Density",
        system: "carrier",
      },
    },
    {
      path: "loads/post-truck",
      name: "postTruck",
      component: () => import("@/views/carrier-common/index.vue"),
      meta: {
        title: "Post Truck",
        system: "carrier",
        keepAlive: true,
      },
    },
  ],
};
